import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const McdDispList = ({ mcdLedgerLineId, mcdInvLineId, partition }) => {
  const { navState } = useNavState();

  const augRowsReq = useCallback(
    (rowsReq) => {
      // 1) Always apply nav filter if present
      if (navState?.expr !== undefined) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, navState.expr);
      }

      // 2) Apply contextual filters if provided (drill-in scenario)
      const whereParams = [];

      if (mcdInvLineId) whereParams.push('mcdInvLineId', mcdInvLineId);
      if (mcdLedgerLineId) whereParams.push('mcdLedgerLineId', mcdLedgerLineId);

      if (whereParams.length) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams(...whereParams));
      }

      // 3) Apply partitions only when relevant/available (avoid forcing when list is “global”)
      if (partition) {
        rowsReq.partition = partition;

        // only set these if you’re actually filtering by ledger line
        if (mcdLedgerLineId) {
          rowsReq.mcdLedgerLineId = mcdLedgerLineId;
          rowsReq.mcdLedgerLinePartition = partition;
        }
      }
    },
    [navState?.expr, mcdLedgerLineId, mcdInvLineId, partition],
  );

  return <EntityList entity="MCD_DISP" augRowsReq={augRowsReq} />;
};
